import { render } from "./AgedBalance.vue?vue&type=template&id=101c81b4&scoped=true"
import script from "./AgedBalance.vue?vue&type=script&lang=js"
export * from "./AgedBalance.vue?vue&type=script&lang=js"

import "./AgedBalance.vue?vue&type=style&index=0&id=101c81b4&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101c81b4"]])

export default __exports__